import * as _ from 'lodash';
import {Injectable} from "@angular/core";

@Injectable()
export class DivisionsProvider {
    divisions = [
        {code: 1, label: 'Exponential Business'},
        {code: 3, label: 'Omnicommerce'},
        // {code: 4, label: 'Franca'},
        {code: 5, label: 'FC Nuvem'},
        // {code: 6, label: 'Projetos Especiais'},
        // {code: 7, label: 'LinkApi'},
        // {code: 8, label: 'Operações Críticas'},
        {code: 9, label: 'Fcamara'},
        {code: 10, label: 'FC Team'},
        {code: 11, label: 'WelcomeApp'},
        // {code: 12, label: 'Orange Founders'},
        {code: 13, label: 'Visual Discovery Suite'},
        {code: 14, label: 'FidelizAluno'},
        {code: 15, label: 'Análises de Contas Médicas'},
        {code: 16, label: 'Health.D'},
        {code: 17, label: 'Hapin'},
        {code: 18, label: 'Orange Ventures'},
        {code: 19, label: 'Imagine'},
        {code: 20, label: 'FC PT'},
    ]

    find(divisionCode) {
        const division = this.divisions.filter(division => division.code == divisionCode);

        if (_.isEmpty(division))
            throw 'Divisão inválida';

        return division;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/enums/divisions.provider.ts